import cx from 'classnames';
import { Component, h } from 'preact';

import { get_directory_slug } from '../election-utils';

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  tableHeader: JSX.Element;
  contestTitle: string;
  contestOffice?: string;
  renderCandidate: any;
  visibleCandidatesCount?: number;
  notes?: { type: string; value: string }[];
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      contestOffice,
      renderCandidate,
      tableHeader,
      notes,
    } = this.props;

    const isNoted = notes && notes.length > 0;

    let totalVotes;

    const isStatewide = contest.division_type === 'statewide';

    let candidates = contest.candidacies;

    let partyName = contest.party;

    const directory_slug = get_directory_slug(contest.office);

    const rowClass = cx('seat__race', {
      'seat__race--Democrat': partyName == 'Democrat',
      'seat__race--Republican': partyName == 'Republican',
    });

    return (
      <div class="seat">
        <div class={rowClass}>
          <div class="race">
            {contestOffice != null && (
              <h2 class="office__title">{contestOffice}</h2>
            )}
            <h4 class="seat__title">
              {contestTitle ? (
                <span>{contestTitle}</span>
              ) : (
                <span>
                  {partyName == 'Democrat' && <span>{partyName}ic</span>}
                  {partyName == 'Republican' && <span>{partyName}</span>}
                </span>
              )}
              {directory_slug[0] && contestTitle && (
                <span class="district__title">
                  <a
                    class="t-links-unset"
                    href={`https://directory.texastribune.org/districts/${directory_slug[0]['directory-slug']}/${contest['office_division']}/`}
                  >
                    <span
                      class="icon-div"
                      title="Click to learn more about this district"
                    >
                      <svg class="icon icon-info">
                        <use xlinkHref="#icon-info"></use>
                      </svg>
                    </span>
                  </a>
                </span>
              )}
            </h4>
            {contestTitle && (
              <h4 class="race__title">
                {partyName == 'Democrat' && <span>{partyName}ic</span>}
                {partyName == 'Republican' && <span>{partyName}</span>}
              </h4>
            )}

            <table class="race__candidates">
              {tableHeader}
              <tbody>
                {candidates.map((candidate: any, idx: any) =>
                  renderCandidate(candidate, idx, {
                    totalVotes,
                  })
                )}
              </tbody>
            </table>
            {isNoted && (
              <p
                class="note__text"
                dangerouslySetInnerHTML={{ __html: notes[0].value }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  visibleCandidatesCount: 3,
};

export default Contest;
